import { ReactNode } from 'react'
import { create } from 'zustand'

export interface Data {
    headerBackFunction?: (() => void) | undefined
    content?: ReactNode
}

interface BuyState {
    data: Data
    setData: (data: Data) => void
}

export const useBuyStore = create<BuyState>(set => ({
    data: {
        headerBackFunction: undefined,
        content: undefined,
    },
    setData: (data: Data) => {
        set(prev => {
            return { ...prev, data }
        })
    },
}))
